import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from '../../../shared/components/tooltip/tooltip.directive';

@Component({
  selector: 'app-resume-consultation-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslateModule, TooltipDirective],
  templateUrl: './resume-consultation-button.component.html',
})
export class ResumeConsultationButtonComponent {
  readonly disabled = input(false);
  readonly tooltip = input<string | null>(null);
  readonly resumeClicked = output<void>();

  onResume(): void {
    if (this.disabled()) return;
    this.resumeClicked.emit();
  }
}
